import { getWindowLocationOrigin } from '../../utils/window'
import { generateMetaTags } from '../../utils/helmet'

const title = 'Download Prospect | IrisVR'
const description =
  'Download Prospect for existing users. Prospect by IrisVR for VR walkthroughs of architecture and construction 3D models.'
const url = `${getWindowLocationOrigin()}/downloads`
const image = 'https://s3.amazonaws.com/iris-opengraph-images/ImgTag_Iris.jpg'
const imageWidth = 1200
const imageHeight = 630

export default generateMetaTags({
  title,
  description,
  image,
  url,
  imageWidth,
  imageHeight,
})
